module.exports = __webpack_public_path__ + "static/top_users_art-3f95652e7bc710cefd9142da74ebf98e.png";